import constants from '../constants';
import getSupportedLocale from './get-supported-locale';

const { SOURCE_LOCALE_REGEXP, SOURCE_FILE_REGEXP, FALLBACK_SOURCE_LOCALE } = constants.common;

// We currently do not host blocks for EN locale under /en/index.html so for it we should shrink locale preffix
// we can delete it if BE would start hosting en blocks under /en/index.html path
const removeFallbackLocalePrefix = (source) => source.replace(`/${FALLBACK_SOURCE_LOCALE}/`, '/');

const normalizeLocalizedSource = (source, currentLocale = '', checkSupportedLocales = true) => {
  if (!currentLocale || !source) return source;
  const match = source.match(SOURCE_LOCALE_REGEXP);
  const sourceLocale = match && match[1];

  const supportedLocale = checkSupportedLocales ? getSupportedLocale(currentLocale) : currentLocale;

  if (!sourceLocale) {
    return removeFallbackLocalePrefix(source.replace(SOURCE_FILE_REGEXP, `/${supportedLocale}$&`));
  }

  return removeFallbackLocalePrefix(source.replace(`/${sourceLocale}/`, `/${supportedLocale}/`));
};

export default normalizeLocalizedSource;
